// Global Instructions Rule Applied!

import { InteractionRecord } from '../data_models/interaction_record.ts'

export type InteractionsState = Record<string, InteractionRecord[]>

const interactionsState: InteractionsState = {}

export { interactionsState }
